import { ErrorMessage } from '@occc-app/lib/ErrorMessage';
import {
  Audience as AudienceAPI,
  Constraint as ConstraintAPI,
  EarningMechanism as EarningMechanismAPI,
  Limit as LimitAPI,
  Offer as OfferAPI,
  MarketingContent as MarketingContentAPI,
} from '@occc-app/Activate/apiTypes';

import {
  AudienceAction,
  AudienceState,
  ConstraintAction,
  ConstraintState,
  EarningMechanismAction,
  EarningMechanismState,
  GetStartedAction,
  GetStartedState,
  LimitAction,
  LimitState,
  MarketingContentAction,
  MarketingContentState,
  MetaDataAction,
  MetaDataState,
} from '../components';

const CLEAR_GET_STARTED_STATE = 'app/Offer/CLEAR_GET_STARTED_STATE';
const CLEAR_OFFER_COMPONENT_STATE = 'app/Offer/CLEAR_OFFER_COMPONENT_STATE';
const REQUEST_OFFER = 'app/Offer/REQUEST_OFFER';
const REQUEST_OFFER_ERR = 'app/Offer/REQUEST_OFFER_ERR';
const REQUEST_OFFER_OK = 'app/Offer/REQUEST_OFFER_OK';

type Types = {
  CLEAR_GET_STARTED_STATE: typeof CLEAR_GET_STARTED_STATE;
  CLEAR_OFFER_COMPONENT_STATE: typeof CLEAR_OFFER_COMPONENT_STATE;
  REQUEST_OFFER: typeof REQUEST_OFFER;
  REQUEST_OFFER_ERR: typeof REQUEST_OFFER_ERR;
  REQUEST_OFFER_OK: typeof REQUEST_OFFER_OK;
};

const types: Types = {
  CLEAR_GET_STARTED_STATE,
  CLEAR_OFFER_COMPONENT_STATE,
  REQUEST_OFFER,
  REQUEST_OFFER_ERR,
  REQUEST_OFFER_OK,
};

/* Actions */
type ClearGetStartedState = () => {
  type: typeof CLEAR_GET_STARTED_STATE;
};

type ClearOfferComponentState = () => {
  type: typeof CLEAR_OFFER_COMPONENT_STATE;
};

type RequestOffer = (offerId: string) => {
  type: typeof REQUEST_OFFER;
  offerId: string;
};

type RequestOfferERR = (
  errorMessages: ErrorMessage[],
  error: Error,
) => {
  type: typeof REQUEST_OFFER_ERR;
  errorMessages: ErrorMessage[];
  error: Error;
};

type RequestOfferAttributes = {
  offerAttributes: OfferAPI;
  audiences: AudienceAPI[];
  constraints: ConstraintAPI[];
  limits: LimitAPI[];
  earningMechanisms: EarningMechanismAPI[];
  marketingContents: MarketingContentAPI[];
};

type RequestOfferOK = (offerAttributes: RequestOfferAttributes) => {
  type: typeof REQUEST_OFFER_OK;
} & RequestOfferAttributes;

export type Action =
  | AudienceAction
  | ConstraintAction
  | EarningMechanismAction
  | GetStartedAction
  | LimitAction
  | MarketingContentAction
  | MetaDataAction
  | ReturnType<ClearGetStartedState>
  | ReturnType<ClearOfferComponentState>
  | ReturnType<RequestOffer>
  | ReturnType<RequestOfferERR>
  | ReturnType<RequestOfferOK>;

export type ActionCreators = {
  ClearGetStartedState: ClearGetStartedState;
  ClearOfferComponentState: ClearOfferComponentState;
  RequestOffer: RequestOffer;
  RequestOfferERR: RequestOfferERR;
  RequestOfferOK: RequestOfferOK;
};

export type SubmissionErrorMessage = {
  property?:
    | 'category'
    | 'chain_id'
    | 'description'
    | 'expire_at'
    | 'external_id'
    | 'name'
    | 'publish_at';
  message: string;
};
export type State = {
  audiences: AudienceState;
  constraints: ConstraintState;
  earningMechanisms: EarningMechanismState;
  limits: LimitState;
  marketingContent: MarketingContentState;
  metaData: MetaDataState;
  getStarted: GetStartedState;
  submission: {
    errorMessages: SubmissionErrorMessage[];
    fireRedirect: boolean;
    offerId: string;
    requesting: boolean;
    submitting: boolean;
  };
};

// Moved here to fix circular dependencies, will be removed along with Offers
export type CreateOfferAppState = Pick<State['metaData'], 'expireAt' | 'publishAt'> &
  Pick<State['getStarted'], 'category' | 'externalId' | 'name' | 'offerDescription'> &
  Pick<State['submission'], 'offerId'> & { chainId: string };

export default types;
